import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import {
    API_URL,
} from "../constants/type";

export const getWorktimeReport = async (pageNumber, noOfRecords, startDate, endDate) => {
    try {
        const companyId = window.localStorage.getItem("companyid");
        if (startDate == null && endDate == null) {
            const response = await axios.get(`${API_URL}/api/TimeManagement/GetWorktimeReport?pageNumber=${pageNumber}&recordPerPage=${noOfRecords}&companyId=${companyId}`);
            return response.data.data;
        }
        else {
            const response = await axios.get(`${API_URL}/api/TimeManagement/GetWorktimeReport?pageNumber=${pageNumber}&recordPerPage=${noOfRecords}&companyId=${companyId}&startDate=${startDate}&endDate=${endDate}`)
            return response.data.data;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const approveWorktimeReport = async (userId) => {
    try {
        const response = await axios.post(`${API_URL}/api/TimeManagement/ApproveWorktimeReport?userID=${userId}`);
        return response.message;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export const DeleteManualTimeSession = async (data) => {
    var dto = {
        ProjectTaskTrackingTimeid: data.projectTaskTrackingTimeid,
        IsDeleted: 1
    };

    const response = await axios({
        method: "post",
        url: `${API_URL}/api/TimeManagement/DeleteManualTimeSession`,
        headers: {
            "Content-Type": "application/json",
        },
        data: dto,
    });
}